import React from 'react';
import { Resource, ResourceInfo, ResourceProps } from 'omni-package-react-core';
import { getProfileApiRoot } from '../../utils/getProfileApiRoot';
import transformAccount from './transformAccount';
import { AccountResponseDto } from '../../interfaces/Dto/AccountResponseDto';

export const AccountResourceInfo: ResourceInfo = {
  name: '/App.features.account.accountResource',
  dataDst: '/App.features.account.current',
};

export interface AccountResourceProps<Data, Error = {}> extends ResourceProps<Data, Error> {
}

const AccountResource = <Data, Error = {}>({ ...props }: AccountResourceProps<Data, Error>) => (
  <Resource
    {...AccountResourceInfo}
    {...props}
    url={`${getProfileApiRoot()}/account`}
    transformResponse={(response: AccountResponseDto) => transformAccount(response)}
  />
);

export default AccountResource;
